import { render, staticRenderFns } from "./DatatableApproveRequests.vue?vue&type=template&id=bbd2fc2a"
import script from "./DatatableApproveRequests.vue?vue&type=script&lang=js"
export * from "./DatatableApproveRequests.vue?vue&type=script&lang=js"
import style0 from "./DatatableApproveRequests.vue?vue&type=style&index=0&id=bbd2fc2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports